export const autoScrollToBottom = (
  container?: HTMLDivElement | null,
  behavior: ScrollBehavior = "smooth",
) => {
  if (!container) return;

  window.requestAnimationFrame(() => {
    container.scrollTo({
      top: container.scrollHeight,
      behavior,
    });
  });
};


